export default __webpack_public_path__ + "fonts/inspiretwdc-heavyitalic.svg";